import { userId } from '../fixture-ids';

// AUTH_LOGGED_OUT is deliberately absent: it has only ever had one shape, declared entirely in
// entries/auth-entries.js.
export const authLegacyAlternates = {};

export const authLegacyFixtures = {
  // The wider legacy value domain -- 'ORG_SWITCH' is never written by the current generation's
  // hardcoded 'AUTH0' constant (auth0-audit-login.js:24).
  AUTH_LOGGED_IN: { action: 'AUTH_LOGGED_IN', debugData: { userId, context: 'ORG_SWITCH' } },
};
